/* eslint-disable */
import React, { useEffect, useState } from "react";
// NAVIGATION
import { useLocation } from "react-router-dom";
// REDUX
import { useSelector } from "react-redux";
import { usePutBankMutation } from "../../../redux/banks/bankAPI";
// CUSTOM HOOKS
import useGetOneBank from "../../../customHooks/GET_requests/useGetOneBank";
// INTERFACES
import { RootState } from "../../../app/store";
import {
  BankInterface,
  BankFloorInterface,
} from "../../../interfaces/Bank.interface";
// COMPONENTS
import BankDetailsCard from "./BanksDetailCard";
import BanksFloorsDetail from "./BanksFloorsDetail";
import IconDefinitionRules from "../adaptersConfiguration/iconDefinition/IconDefinitionRules";
import BanksLiftsDetail from "./BanksLiftsDetail";
import BanksDebounceOverrides from "./BanksDebounceOverrides";
import GlobalAlert2 from "../../home/GlobalAlert2";
import BanksFullView from "./BanksFullView";
// CONSTANTS
import { BLANK_BANK } from "../../../constants/bank";
import { BLANK_ADAPTER } from "../../../constants/adapter";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";

export default function BanksConfiguration() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const idBank = new URLSearchParams(location.search).get("idBank");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [bank, setBank] = useState<BankInterface>({ ...BLANK_BANK });

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [
    triggerPutBank,
    {
      isSuccess: isSuccessPutBank,
      isError: isErrorPutBank,
      error: errorPutBank,
      isLoading: isLoadingPutBank,
      reset: resetPutBank,
    },
  ] = usePutBankMutation();

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { bank: bankHook, isLoadingGetOneBank } = useGetOneBank({
    id: idBank ?? "",
  });

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickSave = async () => {
    const token = await GETJwtToken();
    const copy = structuredClone(bank);
    delete copy.data_blocks;
    copy.lifts = [];
    triggerPutBank({ token, body: copy, id: bank.id });
    resetPutBank();
  };

  const setFloors = (newValue: BankFloorInterface[]) => {
    setBank((prev) => ({
      ...prev,
      bank_floors: newValue,
    }));
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (bankHook && bankHook.id) {
      setBank(bankHook);
    }
  }, [bankHook]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__flexWrap">
      <div
        className={`layout__contentPage__${theme}`}
        style={{
          minWidth: "500px",
          width: "100%",
          overflowX: "auto",
          margin: "5px",
        }}
      >
        <BankDetailsCard
          bank={bank}
          isLoadingGetOneBank={isLoadingGetOneBank}
        />
      </div>
    </div>
  );
}
